<template>
  <div class="filter-container">
    <form novalidate @submit.prevent="searchCompuHistory">
      <div class="row">
        <div class="col-sm-12 col-md-3 mb-md-0 mb-2">
          <custom-drop-down
            v-model="filter.academicYear"
            :options="academicYears"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione Año"
          />
        </div>

        <div class="col-sm-12 col-md-7 mb-md-0 mb-2">
          <custom-drop-down
            v-model="filter.meetingType"
            :options="meetingTypes"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione Tipo de Reunión"
          />
        </div>

        <div
          class="col-sm-12 col-md-2 mb-md-0 mb-2 d-flex justify-content-end align-items-center"
        >
          <action-button
            type="submit"
            text="Buscar"
            variant="success"
            class="ml-2 px-4"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import mixAlert from '@/mixin/alert.mixin';
import { modulesName } from '@/modules';
const { mapState, mapActions } = createNamespacedHelpers(
  modulesName.studentCompuHistoryModuleName
);
import * as studentCompuHistoryTypes from '@/modules/student-compu-history/store/types.js';
const syncedProp = 'result';

export default {
  name: 'CompuHistoryFilter',
  mixins: [mixAlert],
  components: {
    ActionButton,
    CustomDropDown,
  },
  props: {
    [syncedProp]: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    resources: {},
    studentSieId: null,
    filter: {
      academicYear: null,
      meetingType: null,
    },
  }),
  computed: {
    ...mapState({
      academicYears: (state) => state.catalog.compuAcademicYears,
      meetingTypes: (state) => state.catalog.meetingTypes,
    }),
  },
  mounted() {
    this.studentSieId = this.$store.getters.SelectedStudent.studentId;
    this[studentCompuHistoryTypes.ACTION_TYPES.GET_FILTERS](this.studentSieId);
  },
  methods: {
    ...mapActions([
      studentCompuHistoryTypes.ACTION_TYPES.GET_FILTERS,
      studentCompuHistoryTypes.ACTION_TYPES.GET_RESULTS_FILTERED,
    ]),
    searchCompuHistory() {
      const filters = {
        studentSieId: this.studentSieId,
        academicYearId: this.filter.academicYear && this.filter.academicYear.id,
        placementCommitteeCategoryId:
          this.filter.meetingType && this.filter.meetingType.id,
      };

      this[studentCompuHistoryTypes.ACTION_TYPES.GET_RESULTS_FILTERED](filters);
    },
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
}
</style>
